import { useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

export function ForcePasswordChange() {
  const { user, setUser } = useAuth();
  const [f, setF] = useState({ current_password: "", new_password: "", confirm: "" });
  const [busy, setBusy] = useState(false);
  if (!user?.must_change_password || user?.view_only) return null;
  async function save(e) {
    e.preventDefault();
    if (f.new_password !== f.confirm) return toast.error("New passwords do not match");
    setBusy(true);
    try {
      const { data } = await api.post("/auth/change-password", { current_password: f.current_password, new_password: f.new_password });
      if (data.token) localStorage.setItem("sparkora_token", data.token);
      toast.success("Password changed"); setUser({ ...user, must_change_password: false });
    } catch (err) { toast.error(formatApiError(err)); } finally { setBusy(false); }
  }
  return (
    <Dialog open>
      <DialogContent className="max-w-md [&>button]:hidden" onInteractOutside={(e) => e.preventDefault()} onEscapeKeyDown={(e) => e.preventDefault()}>
        <DialogHeader><DialogTitle className="font-display">Set your own password</DialogTitle></DialogHeader>
        <p className="text-sm text-slate-500">You signed in with a starting password from the school. Please choose a new one to continue.</p>
        <form onSubmit={save} className="space-y-3" data-testid="force-password-form">
          <div><Label>Starting password</Label><Input data-testid="fp-current" type="password" value={f.current_password} onChange={(e) => setF({ ...f, current_password: e.target.value })} required className="mt-1" /></div>
          <div><Label>New password (min 6)</Label><Input data-testid="fp-new" type="password" minLength={6} value={f.new_password} onChange={(e) => setF({ ...f, new_password: e.target.value })} required className="mt-1" /></div>
          <div><Label>Confirm new password</Label><Input data-testid="fp-confirm" type="password" value={f.confirm} onChange={(e) => setF({ ...f, confirm: e.target.value })} required className="mt-1" /></div>
          <Button data-testid="fp-save" type="submit" disabled={busy} className="btn-brand w-full">Save password</Button>
        </form>
      </DialogContent>
    </Dialog>
  );
}
